import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from 'rc-datepicker';
import Modal_Frame from "../../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../../hooks/UseFetchData";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import * as XLSX from 'xlsx-js-style';
import Session from "react-session-api";

const todate = new Date();
// const fromdate = todate.getFullYear() - 1 + '/11/04';
const fromdate = new Date();

const SeniorExpenseReport = (props) => {
    const [FromDate, setFromDate] = useState(fromdate);
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [isOpen, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [Count, setCount] = useState();
    const [Employee, setEmployee] = useState('');
    const [Manager, setManager] = useState('');
    const [Status, setStatus] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseprint, fetchDataprint] = UseFetchData();

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const StatusOption = [
        { id: "Exp Approved", title: "Exp Approved" },
        { id: "Manager Approved", title: "Manager Approved" },
        { id: "Manager Rejected", title: "Manager Rejected" },
        // { id: "Paid", title: "Paid" },
        // { id: "CFO Approved", title: "CFO Approved" },
        // { id: "CFO Rejected", title: "CFO Rejected" },
    ];

    const PopulateData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", "");
        bodyFormData.append("EmpName", Employee);
        bodyFormData.append("EmpID", sessionStorage.UID);
        bodyFormData.append("SeniorEmpID", Session.get("UID"));
        bodyFormData.append("Manager", Manager);
        bodyFormData.append("Status", Status);
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("Page", "SeniorExpenseList");
        fetchData("Reports/SeniorAccountReport", bodyFormData);
    }

    const downloadPDF = async (url, fileName) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName || `document_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error(`Error downloading PDF ${fileName}:`, error);
        }
    };

    const Print = async () => {
        if (!rows?.length) {
            console.error("No rows to print");
            return;
        }

        const validRows = rows.filter(row => row.TravelRequestID && !row.id?.toString().includes('_total'));
        const uniqueRowsMap = new Map(validRows.map(row => [row.TravelRequestID, row]));
        const uniqueRows = Array.from(uniqueRowsMap.values());

        if (!uniqueRows.length) {
            console.error("No valid rows selected");
            return;
        }

        try {
            const pdfPromises = uniqueRows.map(async row => {
                const bodyFormData = new FormData();
                bodyFormData.append("TravelRequestID", row.TravelRequestID);
                return fetchDataprint("Dashboard/PDFGenerate", bodyFormData);
            });

            const responses = await Promise.all(pdfPromises);

            for (let i = 0; i < responses.length; i++) {
                const response = responses[i];
                const row = uniqueRows[i];
                if (response?.FileURL) {
                    await downloadPDF(response.FileURL, `${row.TravelRequestNo}.pdf`);
                }
            }
        } catch (error) {
            console.error("Error in PDF generation:", error);
        }
    };

    useEffect(() => {
        if (responseprint) {
            try {
                const data = typeof responseprint === 'string' 
                    ? JSON.parse(responseprint) 
                    : responseprint;

                if (Array.isArray(data)) {
                    data.forEach(async (pdf) => {
                        if (pdf.FileURL) {
                            await downloadPDF(pdf.FileURL, pdf.FileName);
                        }
                    });
                } else if (data?.FileURL) {
                    downloadPDF(data.FileURL, data.FileName);
                }
            } catch (error) {
                console.error("Error handling PDF response:", error);
            }
        }
    }, [responseprint]);

    useEffect(() => {
        const gridCols = [
            {
                field: "EmpName",
                headerName: "Engineer Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "EmpCode",
                headerName: "EngineerID",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "TravelRequestNo",
                headerName: "Unique Id",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "FromDate",
                headerName: "From Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "ToDate",
                headerName: "To Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "ExpenseType",
                headerName: "Expenses",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "GL_Code",
                headerName: "GL Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "ExpenseAmount",
                headerName: "Expense Amount",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "ApprovedAmt",
                headerName: "Approved Amount",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            {
                field: "AccountsApprovedAmt",
                headerName: "Senior Approved Amount",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            
        ];
        setColumns(gridCols);

        if (response.Main !== undefined) {
            const travelRequestExpenseTotals = {};
            const travelRequestApprovedTotals = {};
            const travelRequestAccountsTotals = {};
            const modifiedRows = [];
            
            response.Main.forEach((row) => {
                const modifiedRow = { ...row };
                modifiedRows.push(modifiedRow);
                
                if (!travelRequestExpenseTotals[row.TravelRequestID]) {
                    travelRequestExpenseTotals[row.TravelRequestID] = 0;
                }
                travelRequestExpenseTotals[row.TravelRequestID] += Number(row.ExpenseAmount) || 0;

                if (!travelRequestApprovedTotals[row.TravelRequestID]) {
                    travelRequestApprovedTotals[row.TravelRequestID] = 0;
                }
                travelRequestApprovedTotals[row.TravelRequestID] += Number(row.ApprovedAmt) || 0;

                if (!travelRequestAccountsTotals[row.TravelRequestID]) {
                    travelRequestAccountsTotals[row.TravelRequestID] = 0;
                }
                travelRequestAccountsTotals[row.TravelRequestID] += Number(row.AccountsApprovedAmt) || 0;

                // const nextRow = response.Main.find(r => 
                //     r.EmpName === row.EmpName && 
                //     response.Main.indexOf(r) > response.Main.indexOf(row)
                // );

                const nextRow = response.Main.find(r => 
                    r.TravelRequestID === row.TravelRequestID && 
                    response.Main.indexOf(r) > response.Main.indexOf(row)
                );
                
                if (!nextRow) {
                    modifiedRows.push({
                        id: `${row.TravelRequestID}_total`,
                        EmpName: `Total for ${row.EmpName}`,
                        EmpCode: '',
                        TravelRequestNo: '',
                        FromDate: '',
                        ToDate: '',
                        ExpenseType: '',
                        GL_Code: '',
                        ExpenseAmount: travelRequestExpenseTotals[row.TravelRequestID],
                        ApprovedAmt: travelRequestApprovedTotals[row.TravelRequestID],
                        AccountsApprovedAmt: travelRequestAccountsTotals[row.TravelRequestID]
                    });
                }
            });
            setRows(modifiedRows);
            setCount(modifiedRows.length);
        }
    }, [response]);

    useEffect(() => {
        PopulateData();
    }, []);

    const exportToXlsx = () => {
        const fields = ['EmpName', 'EmpCode', 'TravelRequestNo', 'FromDate', 'ToDate', 'ExpenseType', 'GL_Code', 'ExpenseAmount', 'ApprovedAmt', 'AccountsApprovedAmt'];
        const header = fields;
        const dataRows = rows.map(r => fields.map(f => (r && r[f] !== undefined && r[f] !== null) ? r[f] : ''));
        const sheetData = [header, ...dataRows];
        const ws = XLSX.utils.aoa_to_sheet(sheetData);
        ws['!cols'] = fields.map(() => ({ wch: 22 }));
        for (let c = 0; c < fields.length; c++) {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c });
            if (ws[cellRef]) ws[cellRef].s = { font: { bold: true } };
        }
        rows.forEach((r, idx) => {
            if (r && r.id && r.id.toString().includes('_total')) {
                const rowIndex = idx + 1;
                for (let c = 0; c < fields.length; c++) {
                    const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c });
                    if (ws[cellRef]) ws[cellRef].s = { font: { bold: true } };
                }
            }
        });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Senior Expense Report');
        XLSX.writeFile(wb, 'SeniorExpenseReport.xlsx');
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, paddingRight: 8, overflow: 'visible', width: '100%' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['EmpName', 'EmpCode', 'TravelRequestNo', 'FromDate', 'ToDate', 'ExpenseType', 'GL_Code', 'ExpenseAmount', 'ApprovedAmt', 'AccountsApprovedAmt']
                }} />
                <div style={{ display: 'inline-block' }}>
                    <BiztranControls.Button
                        text="Export XLSX"
                        onClick={exportToXlsx}
                    />
                </div>
            </GridToolbarContainer>
        );
    }

    return (
        <div>
            <Paper elevation={0}>
                <Grid container="row">
                    <Grid xs={12} md={4} sm={3} lg={2} xl={2} >
                        <div style={{ width: "198px", marginLeft: 10, marginTop: -3 }}>
                            <label style={{ color: "grey", fontSize: 12 }}>Sr. Approve From Date</label>
                            <DatePickerInput
                                onChange={(jsDate, dateString) => setFromDate(dateString)}
                                locale="en"
                                displayFormat="DD/MMM/YYYY"
                                onClear={() => { onFromClear(); }}
                                showOnInputClick
                                maxDate={new Date()}
                                returnFormat="YYYY/MM/DD"
                                defaultValue={defaultfromDate}
                            />
                        </div>
                    </Grid>
                    <Grid xs={12} md={4} sm={3} lg={2} xl={2} >
                        <div style={{ width: "198px", marginLeft: 9, marginTop: -3 }}>
                            <label style={{ color: "grey", fontSize: 12 }}>Sr. Approve To Date</label>
                            <DatePickerInput
                                onChange={(jsDate, dateString) => setToDate(dateString)}
                                locale="en"
                                displayFormat="DD/MMM/YYYY"
                                className='my-react-component'
                                onClear={() => { onToClear(); }}
                                showOnInputClick
                                maxDate={new Date()}
                                returnFormat="YYYY/MM/DD"
                                defaultValue={defaultToDate}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} lg={2} xl={2} style={{ marginTop: 10 }}>
                        <BiztranControls.Select
                            label="Status"
                            id="Status"
                            width="185px"
                            options={StatusOption}
                            onChange={(e) => setStatus(e.target.value)}
                        />
                    </Grid>
                </Grid>
                <br />
                <Grid container="row" style={{ marginTop: -5 }} >
                    <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
                        <div style={{ width: "100%", marginLeft: 2, marginTop: 1 }} >
                            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Input
                                    label="Employee"
                                    id="Employee"
                                    onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
                        <div style={{ width: "100%", marginLeft: 0.5, marginTop: 1 }} >
                            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Input
                                    label="Manager"
                                    id="Manager"
                                    onChange={(e) => setManager(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid>

                    <div style={{ float: "left", marginTop: -22, width: "25%", marginRight: -100 }}>
                        <BiztranControls.Button
                            text="SEARCH"
                            startIcon={<SearchIcon />}
                            style={{ marginTop: '10%' }}
                            onClick={() => {
                                PopulateData();
                            }}
                        />
                    </div>
                    <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: -75 }}>
                        <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
                    </div>
                    <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: 10}}>
                        <BiztranControls.Button
                            text="PDF"
                            style={{ marginTop: '10%' }}
                            onClick={() => {
                                Print();
                            }}
                        />
                    </div>
                </Grid>

                <BiztranControls.DataGrid
                    rowHeight={25}
                    headerHeight={34}
                    rows={rows}
                    columns={columns}
                    checkboxSelection={false}
                    Width="107%"
                    Height="400px"
                    hideFooter={false}
                    components={{ Toolbar: CustomToolbar }}
                />
            </Paper>
        </div>
    );
}

export default SeniorExpenseReport;
